import React from 'react';
import { LoadingStateContext } from './LoadingStateContext';
/**
 * Provider component for managing loading state context
 * @public
 */
export const LoadingStateProvider = ({
  children,
  value
}) => {
  return React.createElement(LoadingStateContext.Provider, {
    value: value
  }, children);
};